export enum ThreadStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  AUTOMATICALLY_CLOSED = 'automatically-closed'
}
